type SelectedLabelProp = { 
    labelText: string, 
    totalCount: number,
    selectedAll: boolean,
    handleSelectAll: () => void
}

const SelectedLabel = ({ labelText, totalCount, selectedAll, handleSelectAll }: SelectedLabelProp) => {
    return <div className="phishing-step3__role-list-header">
        <div className="phishing-step3__label">
            {labelText}
            {totalCount > 0 ? (
                <>
                    <span className="phishing-step3__dot"> · </span>
                    <span className="phishing-step3__total-count">
                        {totalCount} user{totalCount > 1 ? "s" : ""} selected
                        <span className="required"> * </span>
                    </span>
                </>
            ) : <span className="required"> * </span>}
        </div>
        {/* <button className="phishing-step3__select-all" onClick={handleSelectAll}>
            {selectedAll ? "Deselect all" : "Select all"}
        </button> */}
    </div>
}

export default SelectedLabel;